import src from "IMAGE";
export default { src, width: 670, height: 535, blurWidth: 0, blurHeight: 0};
